module.exports = __webpack_public_path__ + "static/media/footerChile.89931901.png";